import React, { useState, useEffect } from "react";
import "./CategoryTags.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faPlus } from "@fortawesome/free-solid-svg-icons";

const CategoryTags = ({
  categories = [],
  onChange,
  isStudentView,
  showCategories = true,
}) => {
  const [editingIndex, setEditingIndex] = useState(null);
  const [editValue, setEditValue] = useState("");
  const [localCategories, setLocalCategories] = useState([]);
  const [isAddingCategory, setIsAddingCategory] = useState(false);
  const [newCategory, setNewCategory] = useState("");

  useEffect(() => {
    if (
      categories.length > 0 &&
      JSON.stringify(categories) !== JSON.stringify(localCategories)
    ) {
      setLocalCategories(categories);
    }
  }, [categories]);

  if (isStudentView || !showCategories) return null;

  const handleEditClick = (index, category) => {
    setEditingIndex(index);
    setEditValue(category);
  };

  const handleEditSubmit = (index, e) => {
    e.preventDefault();
    if (editValue.trim()) {
      const newCategories = [...localCategories];
      newCategories[index] = editValue.trim();
      setLocalCategories(newCategories);
      onChange(newCategories);
    }
    setEditingIndex(null);
  };

  const handleDelete = (indexToDelete) => {
    const newCategories = localCategories.filter(
      (_, index) => index !== indexToDelete
    );
    setLocalCategories(newCategories);
    onChange(newCategories);
  };

  const handleAddCategory = (e) => {
    e.preventDefault();
    if (newCategory.trim()) {
      const updatedCategories = [...localCategories, newCategory.trim()];
      setLocalCategories(updatedCategories);
      onChange(updatedCategories);
      setNewCategory("");
      setIsAddingCategory(false);
    }
  };

  return (
    <div className="category-tags">
      {localCategories.map((category, index) => (
        <span key={index} className="category-tag">
          {editingIndex === index ? (
            <form onSubmit={(e) => handleEditSubmit(index, e)}>
              <input
                type="text"
                value={editValue}
                onChange={(e) => setEditValue(e.target.value)}
                onBlur={(e) => handleEditSubmit(index, e)}
                autoFocus
              />
            </form>
          ) : (
            <>
              <span
                className="editable"
                onClick={() => handleEditClick(index, category)}
              >
                {category}
              </span>
              <button
                className="delete-tag"
                onClick={() => handleDelete(index)}
                aria-label="Delete tag"
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </>
          )}
        </span>
      ))}
      {isAddingCategory ? (
        <form onSubmit={handleAddCategory} className="add-category-form">
          <input
            type="text"
            value={newCategory}
            onChange={(e) => setNewCategory(e.target.value)}
            onBlur={() => {
              if (newCategory.trim()) {
                handleAddCategory({ preventDefault: () => {} });
              } else {
                setIsAddingCategory(false);
              }
            }}
            placeholder="New category"
            autoFocus
            className="add-category-input"
          />
        </form>
      ) : (
        <button
          className="add-category-button"
          onClick={() => setIsAddingCategory(true)}
        >
          <FontAwesomeIcon icon={faPlus} />
          Add Category
        </button>
      )}
    </div>
  );
};

export default CategoryTags;
